<div class="p-3">
  <mat-card>
    <mat-card-header>
      <mat-card-title large>{{'ui.titles.not_found' | transloco}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <a [routerLink]="['/']" mat-button>
        {{'ui.buttons.back_to_homepage' | transloco}}
      </a>
    </mat-card-content>
  </mat-card>
</div>
